import React from 'react'
import { Container, Row, Col, Spinner } from 'react-bootstrap'
import Sidebar from '../../comman_page/Sidebar'
import { HeaderDashboard } from '../../comman_page/HeaderDashboard'
import { SharedSelect } from '../../../../../sharedComponents/SharedSelect'
import { SharedButton } from '../../../../../sharedComponents/Button'
import MultiSelect from '../../../../../sharedComponents/MultiSelect'
import { transectionList_new } from '../../../../../Studio-Services/Studio_Services'
import { useState } from 'react'
import { useEffect } from 'react'
import moment from 'moment'
import BootstrapTable from '../../../../../sharedComponents/BootstrapTable'
import { TrDateRange } from '../../../../../sharedComponents/TrDateRange'
import { errorAlert } from '../../../../../Static_Services/Alertmsg'
import { Footer } from '../../../../../public/containers/footer/Footer'
import RefundBotstrapTable from '../../../../../sharedComponents/RefundBotstrapTable'

export const TransactionReport = () => {
  const [trData, setTrData] = useState([]);
  const [totalDetail, setTotalDetail] = useState();
  const [loder, setLoder] = useState(false);
  const [refund, setRefund] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selDay, setSelDay] = useState('');
  const [fulldata, setFulldata] = useState();
  const [fullrefunddata, setFullrefunddata] = useState();
  const [myvaluedate, setMyvaluedate] = useState('');
  const [selpaymethod, setSelpaymethod] = useState([]);
  const [myrefund, setMyrefund] = useState([]);


  const returnSummery = (data, name) => {
    if (!data?.length) return;
    let basePrice = 0.00,
      price = 0.00,
      discount = 0.00,
      adjPrice = 0.00,
      tax1 = 0.00,
      tax2 = 0.00,
      subTotal = 0.00,
      quantity = 0,
      finalTip = 0.00,
      count = 0;

    data.forEach((e) => {
      count += 1;
      let tip = 0.00;
      const parsedTip = parseFloat(e.tip_comment) || 0;
      if (e.tip_comment && !isNaN(parsedTip)) {
        tip = Math.abs(parsedTip);
      }

      const qty = e?.quantity ? parseInt(e.quantity) : 1;
      const base = parseFloat(e?.finalBaseAmount || 0);

      quantity += qty;
      basePrice += base;
      price += base * qty;
      discount += parseFloat(e?.finalDiscount || 0);
      adjPrice += parseFloat(e?.finalAdjustPrice || 0);
      tax1 += parseFloat(e?.finalTax1 || 0);
      tax2 += parseFloat(e?.finalTax2 || 0);
      subTotal += parseFloat(e?.finalAdjustPrice || 0) + tip + parseFloat(e?.finalTax1 || 0) + parseFloat(e?.finalTax2 || 0);
      // quantity += typeof e.quantity === 'number' ? Math.max(1, e.quantity) : 1;

      finalTip += tip;
    });

    return {
      summary: name,
      transaction: count,
      basePrice: basePrice.toFixed(2),
      price: price.toFixed(2),
      quantity: quantity,
      discount: discount.toFixed(2),
      adjPrice: adjPrice.toFixed(2),
      tip: finalTip.toFixed(2),
      tax1: tax1.toFixed(2),
      tax2: tax2.toFixed(2),
      subTotal: subTotal.toFixed(2),
    };
  };


  const getReport = async (day = '', slsd = '', sled = '', mode = '', pg) => {
    setMyrefund([]);
    let pymod = []
    if (selpaymethod && selpaymethod.length > 0) { selpaymethod.forEach((data) => { pymod.push(data.value); }) }
    const crt = pymod.find((e) => e === "credit");
    if (crt) { pymod.push('visa', 'mastercard', 'amEx', "mc"); }

    let today = '';
    let start = '';
    let end = '';
    let page = 1;
    if (pg) { page = pg; }
    setLoder(true);
    if (day && day === 'today') { setStartDate(''); setEndDate(''); start = ''; end = ''; today = moment().format('YYYY-MM-DD'); }

    if (day && day === 'yesterday') { setStartDate(''); setEndDate(''); start = ''; end = ''; today = moment().subtract(1, 'day').format('YYYY-MM-DD'); }

    if (day && day === 'last7') { setStartDate(''); setEndDate(''); start = moment().subtract(6, 'days').startOf('day'); end = moment().endOf('day'); today = ''; }

    if (day && day === 'lastweek') {
      start = moment().subtract(1, 'week').startOf('isoWeek').format('YYYY-MM-DD');
      end = moment().subtract(1, 'week').endOf('isoWeek').format('YYYY-MM-DD');
      today = '';
      setStartDate(''); setEndDate('');
    }

    if (day && day === 'current_month') { setStartDate(''); setEndDate(''); start = moment().startOf('month').format('YYYY-MM-DD'); end = moment().endOf('month').format('YYYY-MM-DD'); today = '' }
    if (day && day === 'last_month') { setStartDate(''); setEndDate(''); start = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'); end = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'); today = '' }
    if (!day && slsd && sled) { start = slsd; end = sled; today = ''; setSelDay(''); }


    const newpaymode = pymod.filter((vi) => vi.replace(/\s/g, '').toLowerCase() != 'refunded');

    const rfpaymode = pymod.filter((vi) => vi.replace(/\s/g, '').toLowerCase() === 'refunded');
    let setrefundstatus = '';

    if (rfpaymode && rfpaymode.length > 0) {
      setrefundstatus = 1;
      setRefund(true);
    }

    const fdata = { "page_no": page, 'todayDate': today, 'startDate': start, 'endDate': end, "paymode": newpaymode, "refund": setrefundstatus }


    const resp = await transectionList_new(fdata);
    if (resp) {
      let array = [];
      let refundArray = []
      let pre = resp.data;
      const tabledata = ({ 'td': pre, 'paymode': pymod });
      setFulldata(tabledata);

      const cash = pre.filter((vi) => vi.payment_mode.replace(/\s/g, '').toLowerCase() === 'cash');
      const pos = pre.filter((vi) => vi.payment_mode.replace(/\s/g, '').toLowerCase() === 'pos');
      const pass = pre.filter((vi) => vi.payment_mode.replace(/\s/g, '').toLowerCase() === 'pass');
      const giftcard = pre.filter((vi) => vi.payment_mode.replace(/\s/g, '').toLowerCase() === 'giftcard');
      const check = pre.filter((vi) => vi.payment_mode.replace(/\s/g, '').toLowerCase() === 'check');
      const directdebit = pre.filter((vi) => vi.payment_mode.replace(/\s/g, '').toLowerCase() === 'directdebit');
      const freepass = pre.filter((vi) => vi.payment_mode.replace(/\s/g, '').toLowerCase() === 'freepass');

      const other = pre.filter((vi) => vi.payment_mode.replace(/\s/g, '').toLowerCase() === '' || vi.payment_mode.replace(/\s/g, '').toLowerCase() === 'visa' || vi.payment_mode.replace(/\s/g, '').toLowerCase() === 'mastercard' || vi.payment_mode.replace(/\s/g, '').toLowerCase() === 'amex' || vi.payment_mode.replace(/\s/g, '').toLowerCase() === 'cron' || vi.payment_mode.replace(/\s/g, '').toLowerCase() === 'mc');

      const refunded = pre.filter((vi) => vi.refund_status.replace(/\s/g, '').toLowerCase() == '1');

      const fullrefundtabledata = ({ 'td': refunded, 'paymode': pymod });
      setFullrefunddata(fullrefundtabledata);

      if (cash && cash.length > 0) { const res = returnSummery(cash, 'Cash'); array.push(res); };
      if (pos && pos.length > 0) { const res = returnSummery(pos, 'POS'); array.push(res); };
      if (pass && pass.length > 0) { const res = returnSummery(pass, 'Pass'); array.push(res); };
      if (giftcard && giftcard.length > 0) { const res = returnSummery(giftcard, 'Gift Card'); array.push(res); };
      if (check && check.length > 0) { const res = returnSummery(check, 'Check'); array.push(res); };
      if (directdebit && directdebit.length > 0) { const res = returnSummery(directdebit, 'Direct Debit'); array.push(res); };
      if (other && other.length > 0) { const res = returnSummery(other, 'Credit/Debit'); array.push(res); };
      if (freepass && freepass.length > 0) { const res = returnSummery(freepass, 'Free Pass'); array.push(res); };
      if (refunded && refunded.length > 0) { const res = returnSummery(refunded, 'Refunded'); refundArray.push(res); };

      if (refundArray && refundArray.length > 0) {
        setRefund(true);
      }

      setMyrefund(refundArray);

      let tr = 0;
      let totBasePrice = 0;
      let totPrice = 0;
      let totTip = 0;
      let totQuantity = 0;
      let totDiscount = 0;
      let totAdjPrice = 0;
      let totTax1 = 0;
      let totTax2 = 0;
      let totSubTotal = 0;
      if (array && array.length > 0) {
        array.forEach((e) => {
          tr += e.transaction;
          totBasePrice += parseFloat(e.basePrice);
          totPrice += parseFloat(e.price);
          totQuantity += parseFloat(e.quantity);
          totTip += parseFloat(e.tip);
          totDiscount += parseFloat(e.discount);
          totAdjPrice += parseFloat(e.adjPrice);
          totTax1 += parseFloat(e.tax1);
          totTax2 += parseFloat(e.tax2);
          totSubTotal += parseFloat(e.subTotal);
        })
      }

      const final = {
        Transection: tr,
        totBasePrice: parseFloat(totBasePrice).toFixed(2),
        totPrice: parseFloat(totPrice).toFixed(2),
        totQuantity: parseFloat(totQuantity),
        totTip: parseFloat(totTip).toFixed(2),
        totDiscount: parseFloat(totDiscount).toFixed(2),
        totAdjPrice: parseFloat(totAdjPrice).toFixed(2),
        totTax1: parseFloat(totTax1).toFixed(2),
        totTax2: parseFloat(totTax2).toFixed(2),
        totSubTotal: parseFloat(totSubTotal).toFixed(2),
      }

      setTotalDetail(final);
      setTrData(array);
      setLoder(false);
    } else {
      setTrData([]);
      setTotalDetail();
      setMyrefund([]);
      setLoder(false);
    }
    setLoder(false);
  }

  const columnsth = ["Summary", "Transaction", "Base Price", "Quantity", "Price", "Discount", "Adj Price", "Tip", "Tax 1", "Tax 2", "Total"];
  const refund_columns_th = ["Summary", "Transaction", "Base Price", "Quantity", "Price", "Discount", "Adj Price", "Tip", "Tax 1", "Tax 2", "Total"];

  const payOption = [
    { value: "credit", label: "Credit/Debit" },
    { value: "cron", label: "Recurring" },
    { value: "cash", label: "Cash" },
    { value: "pos", label: "POS" },
    { value: "pass", label: "Pass" },
    { value: "giftcard", label: "Gift Card" },
    { value: "check", label: "Check" },
    { value: "directdebit", label: "Direct Debit" },
    { value: "refunded", label: "Refunded" },
  ];

  const dayOption = [
    { value: "", label: "Select" },
    { value: "today", label: "Today" },
    { value: "yesterday", label: "yesterday" },
    { value: "last7", label: "Last 7 Days" },
    { value: "lastweek", label: "Last Week" },
    { value: "current_month", label: "Current Month" },
    { value: "last_month", label: "Last Month" },
  ]

  const downloadCSV = async () => {
    setLoder(true);
    if (trData && trData.length > 0) {
      setLoder(false);
      const csvContent = "summary,transaction,before_tax,tax_one,tax_two,total\n" + trData.map((data, index) =>
        `${data.summary},${data.transaction},${data.before_tax},${data.tax_one},${data.tax_two},${data.total}`
      ).join("\n");
      const blob = new Blob([csvContent], { type: 'text/csv' });
      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = 'Transection_list.csv';
      downloadLink.click();
    } else errorAlert('Please Select Data');
    setLoder(false);
  }


  const handleDayClick = (e) => {
    if (e.target.value) {
      setMyvaluedate(null); setSelpaymethod([]); setStartDate(''); setEndDate(''); setSelDay(e.target.value);
      let value = e.target.value;

      getReport(value, '', "", ""); setRefund(true);
    } else {
      setTrData([]);
      setTotalDetail();

    }
  }


  const runreportHandler = () => {
    if (!startDate || !endDate) { errorAlert("Please Select Date"); return; }
    setSelDay('');
    getReport('', startDate, endDate, selpaymethod,)
  }

  useEffect(() => { if (selDay && selDay != '') { getReport(selDay, '', '', selpaymethod,) } }, [selpaymethod])

  const clearHandler = () => {
    setMyvaluedate('');
    setSelpaymethod([]);
    setSelDay('');
    setTrData([]);
    setTotalDetail();
    setMyrefund([]);
  }

  useEffect(() => {
    if (myvaluedate) {
      setSelDay('');
      setTrData([]);
      setTotalDetail();
    }
  }, [myvaluedate])

  return (
    <>
      {loder ? <div className='MainLoader'> <Spinner animation="border" role="status" className='Loader'> <span className="visually-hidden">Loading...</span>  </Spinner> </div> : ""}
      <div className="MainDashboard">
        <div className="MainLayout">
          <Row>
            <Sidebar />
            <Col>
              <div className="RightSide">
                <HeaderDashboard />
                <section className="addClient innerContent">
                  <div className="AddClientContent" style={{ padding: '0px' }}>
                    <Container className='py-4'>
                      <h4 className='mb-4'>Transaction Report</h4>

                      <Row>
                        <Col className='d-flex'>
                          <Col md={11}>
                            <SharedSelect lable={"Quick Date Range "} value={selDay} options={dayOption} onChange={handleDayClick} />
                          </Col>
                          <span className='mycls'>Or</span>
                        </Col>
                        <Col>
                          <TrDateRange
                            myvalye={myvaluedate}
                            setMyvalye={setMyvaluedate}
                            label={" Manual Date Range "}
                            setStartDate={setStartDate}
                            setEndDate={setEndDate}
                          />
                        </Col>
                        <Col>
                          <MultiSelect Label={"Payment Method"} options={payOption} setSelectedOptions={setSelpaymethod} selectedOptions={selpaymethod} />
                        </Col>
                      </Row>
                      <Row>
                        <Col className='d-flex justify-content-end' >
                          <button type="button" className="btn btn-success m-1" onClick={runreportHandler}>Run Report</button>
                          <button type="button" className="btn btn-success m-1" onClick={downloadCSV}>Export (CSV)</button>
                          <button type="button" className="btn btn-danger m-1" onClick={clearHandler}>Clear Report </button>
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col>
                          <div className="transactionReport">
                            <BootstrapTable th={columnsth} tr={trData} totalDetail={totalDetail} myrefund={myrefund} />
                          </div>
                        </Col>
                      </Row>
                      {totalDetail &&
                        <>
                          <Row>
                            <Col>
                              <SharedButton title={"View Details"} type={"button"} element={fulldata} href={"/transactiondetailreport"} variant={"secondary"} className={'text-capitalize'} />
                            </Col>
                            <Col></Col>
                            <Col></Col>
                          </Row>
                        </>
                      }

                      {myrefund && myrefund.length > 0 && refund &&
                        <>
                          <Row className="mt-5">
                            <Row><h3>Refund Data Summary</h3></Row>
                            <Col>
                              <div className="transactionReport">
                                <RefundBotstrapTable th={refund_columns_th} tr={myrefund} />
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <SharedButton title={"View Details"} type={"button"} element={fullrefunddata} href={"/transactiondetailreport"} variant={"secondary"} className={'text-capitalize'} />
                            </Col>
                            <Col></Col>
                            <Col></Col>
                          </Row>
                        </>
                      }
                    </Container>
                  </div>
                </section>
                <Footer />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  )
}
